export default "__VITE_ASSET__B_CBaDab__"